/* eslint-disable */
import { createWebHistory, createRouter } from "vue-router";
import Store from "../store";
import ErrorComponent from "@/components/Error";
import DataLayerService from "@/services/data-layer.service";

var Page = [
  "DealCreate",
  "SiteCreate",
  "Performance",
  "VisitRatio",
  "MyAmbassadors",
  "MyFriends",
];
async function requireAuth(to, from, next) {
  // Most auth and route validation is now handled by the global beforeEach guard
  // This function now only handles company-specific user info loading logic

  const _userInfo = Store.state.cognitoInfo;
  if (
    _userInfo &&
    (_userInfo.companyid == null ||
      _userInfo.companyid == undefined ||
      _userInfo.companyid == "")
  ) {
    await DataLayerService.get("/user/getuserinfo").then(async (userRes) => {
      if (userRes) {
        if (
          userRes.companyId == "" ||
          userRes.companyId == null ||
          userRes.companyId == undefined
        ) {
          this.$router.push({ name: "Logout" });
          return;
        }
        var mainres = {};
        mainres.email = _userInfo.email;
        mainres.username = _userInfo.username;
        mainres.displayname = userRes.displayName;
        mainres.companyid = userRes.companyId;
        mainres.companyname = userRes.companyName;
        mainres.companylist = userRes.companyIdList;
        mainres.role = userRes.role;
        mainres.token = Store.state.cognitoInfo.token;
        await Store.commit("setCognitoInfo", mainres);
        return mainres;
      } else {
        next({ name: "Logout" });
        return;
      }
    });
  }

  if (
    [
      "DealCreate",
      "SiteCreate",
      "Performance",
      "VisitRatio",
      "MyAmbassadors",
      "MyFriends",
    ].includes(to.name) &&
    _userInfo.companyid === "_all" &&
    from.name === null
  ) {
    next({ name: "Home" });
    return;
  }

  next();
}

const routes = [
  {
    path: Store.getters.GetRoutePath("home"),
    name: "Home",
    //component: () => import("../views/Home.vue"),
    // component: () => import("../views/Dashboard/Dashboard.vue"),
    component: () => import("../views/VoyadoDashboard/voyadodashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("newsitelist"),
    name: "NewSiteList",
    component: () => import("../views/NewSite/Site.vue"),
  },
  {
    path: Store.getters.GetRoutePath("elevatelist"),
    name: "elevatelist",
    component: () => import("../views/AcceleratorConfiguration/Elevate/ElevateSites.vue"),
  },
  {
    path: Store.getters.GetRoutePath("elevateedit"),
    name: "elevateedit",
    component: () => import("../views/AcceleratorConfiguration/Elevate/ElevateConfig.vue"),
  },
  {
    path: Store.getters.GetRoutePath("acceleratorsite"),
    name: "acceleratorsite",
    component: () => import("../views/AcceleratorConfiguration/ECommerce/ECommerceSite.vue"),
  },
  {
    path: Store.getters.GetRoutePath("acceleratoredit"),
    name: "acceleratoredit",
    component: () => import("../views/AcceleratorConfiguration/ECommerce/ECommerceConfig.vue"),
  },
  {
    path: Store.getters.GetRoutePath("leadadslist"),
    name: "leadadslist",
    component: () => import("../views/AcceleratorConfiguration/LeadAds/LeadadsSite.vue"),
  },
  {
    path: Store.getters.GetRoutePath("leadads"),
    name: "leadadsedit",
    component: () => import("../views/AcceleratorConfiguration/LeadAds/LeadadsConfig.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("newsitecreate"),
    name: "NewSiteCreate",
    component: () => import("../views/NewSite/SiteCreate.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("newsiteedit"),
    name: "NewSiteEdit",
    component: () => import("../views/NewSite/SiteCreate.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("newsitecopy"),
    name: "NewSiteCopy",
    component: () => import("../views/NewSite/SiteCreate.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("sitelist"),
    name: "SiteList",
    component: () => import("../views/Site/Site.vue"),
  },
  {
    path: Store.getters.GetRoutePath("sitecreate"),
    name: "SiteCreate",
    component: () => import("../views/Site/Create.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("siteedit"),
    name: "SiteEdit",
    component: () => import("../views/Site/Create.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: Store.getters.GetRoutePath("sitecopy"),
    name: "SiteCopy",
    component: () => import("../views/Site/Create.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("siteChangelog"),
    name: "SiteChangelog",
    component: () => import("../views/Reports/SiteChangelog.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("companyChangelog"),
    name: "CompanyChangelog",
    component: () => import("../views/Reports/CompanyChangelog.vue"),
    beforeEnter: requireAuth,
  },
  // {
  //   path: Store.getters.GetRoutePath("dealcreate"),
  //   name: "DealCreate",
  //   component: () => import("../views/Deal/Create.vue"),
  //   beforeEnter: requireAuth,
  // },
  {
    path: Store.getters.GetRoutePath("performance"),
    name: "Performance",
    component: () => import("../views/Reports/Performance/Performance.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("myambassadors"),
    name: "Ambassadors",
    component: () => import("../views/Reports/MyAmbassadors/MyAmbassadorsDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("myfriends"),
    name: "Friends",
    component: () => import("../views/Reports/MyFriends/MyFriendsDashboard.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: Store.getters.GetRoutePath("relations"),
    name: "Relations",
    component: () => import("../views/Reports/Relations/RelationsDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("companylist"),
    name: "CompanyList",
    component: () => import("../views/Company/CompanyList.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("companycreate"),
    name: "CompanyCreate",
    component: () => import("../views/Company/CompanyIndex.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("companyedit"),
    name: "CompanyEdit",
    component: () => import("../views/Company/CompanyIndex.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("changelog"),
    name: "Changelog",
    component: () => import("../views/Reports/Changelog.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("userlist"),
    name: "UserList",
    component: () => import("../views/User/User.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("usercreate"),
    name: "UserCreate",
    component: () => import("../views/User/CreateUser.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("useredit"),
    name: "UserEdit",
    component: () => import("../views/User/CreateUser.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("ratingreviewlist"),
    name: "RatingReviewList",
    component: () => import("../views/RatingsAndReviews/RatingsAndReviews.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("ratingreviewedit"),
    name: "RatingReviewEdit",
    component: () => import("../views/RatingsAndReviews/RatingsAndReviewsEdit.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("updatetranslation"),
    name: "Translation",
    component: () => import("../views/Translation/Translation.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("contactlist"),
    name: "FailedContact",
    component: () => import("../views/OperationDashboard/FailedContact/FailedContact.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("errorsummary"),
    name: "Error",
    component: () => import("../views/OperationDashboard/OnsiteErrors/ErrorSummary.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("calllogsite"),
    name: "calllog",
    component: () => import("../views/OperationDashboard/CallLogs/CallLogDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("calllogview"),
    name: "calllogbykeyid",
    component: () => import("../views/OperationDashboard/CallLogs/CallLogView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("sessionssite"),
    name: "sessiondashboard",
    component: () => import("../views/OperationDashboard/Sessions/SessionsSite.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("sessionsdashboard"),
    name: "sessiondashboardbyid",
    component: () => import("../views/OperationDashboard/Sessions/SessionsDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("sessionsview"),
    name: "sessiondashboardbykeyid",
    component: () => import("../views/OperationDashboard/Sessions/SessionsView.vue"),
    beforeEnter: requireAuth,
  },
  // {
  //   path: Store.getters.GetRoutePath("sessionlogsite"),
  //   name: "sessionlogdashboard",
  //   component: () => import("../views/OperationDashboard/SessionLogs/SessionLogSite.vue"),
  //   beforeEnter: requireAuth,
  // },
  {
    path: Store.getters.GetRoutePath("sessionlogdashboard"),
    name: "sessionlogdashboardbyid",
    component: () => import("../views/OperationDashboard/SessionLogs/SessionLogDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("sessionlogview"),
    name: "sessionlogdashboardbykeyid",
    component: () => import("../views/OperationDashboard/SessionLogs/SessionLogView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("companyerrordashboard"),
    name: "errorlogbycompany",
    component: () => import("../views/OperationDashboard/ErrorLogs/CompanyErrorDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("companyerrorview"),
    name: "errorlogbycompanyid",
    component: () => import("../views/OperationDashboard/ErrorLogs/CompanyErrorView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("ongoingerrordashboard"),
    name: "ongoingerror",
    component: () => import("../views/OperationDashboard/OngoingErrors/CompanyOngoingErrorDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("ongoingerrorview"),
    name: "ongoingerrorbyerrorlogid",
    component: () => import("../views/OperationDashboard/OngoingErrors/CompanyOngoingErrorView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("allongoingerrordashboard"),
    name: "allongoingerror",
    component: () => import("../views/OperationDashboard/AllOngoingErrors/CompanyAllOngoingErrorDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("allongoingerrorview"),
    name: "allongoingerrorbyerrorlogid",
    component: () => import("../views/OperationDashboard/AllOngoingErrors/CompanyAllOngoingErrorView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("activeorders"),
    name: "activeorders",
    component: () => import("../views/OperationDashboard/ActiveOrders/ActiveOrdersDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("modifydeal"),
    name: "ModifyDeal",
    component: () => import("../views/DealList/List.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("managedeallistnew"),
    name: "ManageDealListNew",
    component: () => import("../views/ManageDealsNew/List.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("newonsitemessage"),
    name: "NewOnsiteMessage",
    component: () => import("../views/UpdateDealNew/Update.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("copydeal"),
    name: "copydeal",
    component: () => import("../views/ManageDealUpdate/index.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("copydealnew"),
    name: "copydealnew",
    component: () => import("../views/UpdateDealNew/Update.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("dealsearch"),
    name: "DealSearch",
    component: () => import("../views/Reports/DealSearch.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("notfound"),
    name: "notfound",
    component: () => import("../views/Pages/Notfound.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("signupwizard"),
    name: "Signupwizard",
    component: () => import("../views/signupwizard/signupwizard.vue"),
    beforeEnter: requireAuth,
  },
  // {
  //   path: Store.getters.GetRoutePath("managedealupdate"),
  //   name: "ManageDealUpdate",
  //   component: () => import("../views/ManageDealUpdate/index.vue"),
  //   beforeEnter: requireAuth,
  // },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: () => import("../views/forgotpassword.vue"),
  },
  {
    path: "/resetpassword",
    name: "ResetPassword",
    component: () => import("../views/resetpassword.vue"),
  },
  {
    path: "/changepassword",
    name: "ChangePassword",
    component: () => import("../views/changepassword.vue"),
  },

  {
    path: Store.getters.GetRoutePath("managedealupdateCreate"),
    name: "ManageDealUpdateCreate",
    component: () => import("../views/ManageDealUpdate/index.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: Store.getters.GetRoutePath("editdealnew"),
    name: "EditDealNew",
    component: () => import("../views/UpdateDealNew/Update.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: Store.getters.GetRoutePath("managedealupdateById"),
    name: "ManageDealUpdateById",
    component: () => import("../views/ManageDealUpdate/index.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("contentgenerator"),
    name: "contentgenerator",
    component: () => import("../views/ContentGenerator/contentgenerator.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("aicontent"),
    name: "aicontent",
    component: () => import("../views/AiContent/aicontent.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("aivideocontent"),
    name: "aivideocontent",
    component: () => import("../views/AiContent/aiVideoContent.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: Store.getters.GetRoutePath("essence"),
    name: "essence",
    component: () => import("../views/Essence/index.vue"),
  },
  // {
  //   path: "/login",
  //   name: "Login",
  //   beforeEnter() {
  //     // console.log(auth.auth.getSession(), 'auth.auth.getSession()')
  //     auth.auth.getSession();
  //   },
  // },
  // {
  //   path: "/login/oauth2/code/cognito",
  //   name: "LoginCognito",
  //   beforeEnter() {
  //     var currUrl = window.location.href;
  //     auth.auth.parseCognitoWebResponse(currUrl);
  //   },
  // },
  {
    path: "/error",
    component: ErrorComponent,
    beforeEnter: requireAuth,
  },
  {
    path: "/logout",
    name: "Logout",
    beforeEnter(to, from, next) {
      Store.state.loader = 0;
      Store.commit("resetCallLogLogout");
      Store.commit("resetErrorLogsSite");
      Store.commit("resetErrorIntegrationsValue");
      Store.commit("resetErrorModuleValue");
      
      Store.commit("resetCognitoInfo");
      Store.commit("resetMenudataInfo");
      Store.commit("resetRoutedataInfo");
      Store.commit("resetDealFilter");
      Store.commit("resetDashboardInfo");
      Store.commit("resetDashbboardFilter");
      Store.commit("resetLead");
      Store.commit("resetFacebookPopup");
      Store.commit("resetIntegrationsValue");
      Store.commit("resetModuleValue");
      Store.commit("resetAcceleratorProducts");
      Store.commit("resetAcceleratorOrders");
      Store.commit("resetOrderIntegrationsValue");
      Store.commit("resetNotifiedErrorCount");
      Store.commit("resetAcceleratorMarket");
      Store.commit("resetAcceleratorContact");
      Store.commit("resetContactIntegrationsValue");
      Store.commit("resetAcceleratorInventory");
      Store.commit("resetInventoryIntegrationsValue");
      Store.commit("resetAcceleratorReceipt");
      Store.commit("resetReceiptIntegrationsValue");
      Store.commit("resetOnLogout");

      const queryParams = from.query;
      console.log(queryParams, "queryparams after logout route called");
      
      next({ path: "/login", query: queryParams });
    },
  },
  // {
  //   path: "/logout",
  //   name: "Logout",
  //   beforeEnter(to, from, next) {
  //     // console.log(auth,876);
  //     auth.logout();
  //     next("/");
  //   },
  // },
  {
    path: Store.getters.GetRoutePath("blank"),
    name: "Blank",
    component: () => import("../views/Blank.vue"),
  },
  {
    path: Store.getters.GetRoutePath("onsitedashboard"),
    name: "OnsiteDashboard",
    component: () => import("../views/Dashboard/Dashboard.vue"),
  },

  {
    path: Store.getters.GetRoutePath("overview"),
    name: "VoyadoDashboard",
    component: () => import("../views/VoyadoDashboard/voyadodashboard.vue"),
    beforeEnter: requireAuth,
  },
  // {
  //   path: Store.getters.GetRoutePath("acceleratordashboard"),
  //   name: "acceleratordashboard",
  //   component: () => import("../views/AcceleratorDashboard/Accelerator.vue"),
  // },
  {
    path: Store.getters.GetRoutePath("productsite"),
    name: "acceleratordashboardproducts",
    component: () => import("../views/AcceleratorDashboard/Products/ProductSites.vue"),
  },
  {
    path: Store.getters.GetRoutePath("productdashboard"),
    name: "acceleratordashboardproductsbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Products/ProductDashboard.vue"),
  },
  {
    path: Store.getters.GetRoutePath("productview"),
    name: "acceleratordashboardproductbykeyid",
    component: () => import("../views/AcceleratorDashboard/Products/ProductView.vue"),
  },
  {
    path: Store.getters.GetRoutePath("ordersite"),
    name: "acceleratordashboardorders",
    component: () => import("../views/AcceleratorDashboard/Orders/OrderSites.vue"),
  },
  {
    path: Store.getters.GetRoutePath("orderdashboard"),
    name: "acceleratordashboardordersbyid",
    component: () => import("../views/AcceleratorDashboard/Orders/OrderDashboard.vue"),
  },
  {
    path: Store.getters.GetRoutePath("orderview"),
    name: "acceleratordashboardorderbykeyid",
    component: () => import("../views/AcceleratorDashboard/Orders/OrderView.vue"),
  },
  {
    path: Store.getters.GetRoutePath("contactsite"),
    name: "acceleratordashboardcontacts",
    component: () => import("../views/AcceleratorDashboard/Contacts/ContactSites.vue"),
  },
  {
    path: Store.getters.GetRoutePath("contactdashboard"),
    name: "acceleratordashboardcontactsbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Contacts/ContactDashboard.vue"),
  },
  {
    path: Store.getters.GetRoutePath("contactview"),
    name: "acceleratordashboardcontactsbykeyid",
    component: () => import("../views/AcceleratorDashboard/Contacts/ContactView.vue"),
  },
  {
    path: Store.getters.GetRoutePath("inventorysite"),
    name: "acceleratordashboardinventories",
    component: () => import("../views/AcceleratorDashboard/Inventories/InventorySites.vue"),
  },
  {
    path: Store.getters.GetRoutePath("inventorydashboard"),
    name: "acceleratordashboardinventoriesbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Inventories/InventoryDashboard.vue"),
  },
  {
    path: Store.getters.GetRoutePath("inventoryview"),
    name: "acceleratordashboardinventoriesbykeyid",
    component: () => import("../views/AcceleratorDashboard/Inventories/InventoryView.vue"),
  },
  {
    path: Store.getters.GetRoutePath("marketsite"),
    name: "acceleratordashboardmarkets",
    component: () => import("../views/AcceleratorDashboard/Markets/MarketSites.vue"),
  },
  {
    path: Store.getters.GetRoutePath("marketdashboard"),
    name: "acceleratordashboardmarketsbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Markets/MarketDashboard.vue"),
  },
  {
    path: Store.getters.GetRoutePath("marketview"),
    name: "acceleratordashboardmarketsbyidkeyid",
    component: () => import("../views/AcceleratorDashboard/Markets/MarketView.vue"),
  },
  {
    path: Store.getters.GetRoutePath("receiptsite"),
    name: "acceleratordashboardreceipt",
    component: () => import("../views/AcceleratorDashboard/Receipts/ReceiptSites.vue"),
  },
  {
    path: Store.getters.GetRoutePath("receiptdashboard"),
    name: "acceleratordashboardreceiptbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Receipts/ReceiptDashboard.vue"),
  },
  {
    path: Store.getters.GetRoutePath("receiptview"),
    name: "acceleratordashboardreceiptbyidkeyid",
    component: () => import("../views/AcceleratorDashboard/Receipts/ReceiptView.vue"),
  },
];

// Add a catch-all route for unmatched paths
routes.push({
  path: "/:pathMatch(.*)*",
  name: "CatchAll",
  component: () => import("../views/Pages/Notfound.vue"),
});

const router = createRouter({
  history: createWebHistory(),
  // base:"/",
  routes,
});

router.beforeEach(async (to, from, next) => {
  Store.commit("setActiveRoute", to.meta.module);
  
  // Skip validation for authentication and error routes
  const skipValidationRoutes = [
    "Login", 
    "Logout", 
    "ForgotPassword", 
    "ResetPassword", 
    "ChangePassword", 
    "notfound", 
    "CatchAll"
  ];
  
  if (skipValidationRoutes.includes(to.name)) {
    next();
    return;
  }
  
  // Check if user is authenticated
  if (
    !Store.state.cognitoInfo ||
    Object.keys(Store.state.cognitoInfo).length === 0
  ) {
    let decodedPath = decodeURIComponent(to.fullPath);
    console.log(decodedPath, "redirecting to login page");

    const url = new URL(window.location.origin + to.fullPath);
    const queryParams = new URLSearchParams(url.search);
    const queryString = queryParams.toString();

    let redirectPath = to.path;
    if (queryString) {
      redirectPath += `&${queryString}`;
    }

    next({
      path: "/login",
      query: {
        redirect: redirectPath,
      },
    });
    return;
  }
  
  // Ensure menu data is loaded
  if (
    !Store.state.menudataInfo ||
    Object.keys(Store.state.menudataInfo).length === 0
  ) {
    try {
      const result = await DataLayerService.get("/home/GetMenuData");
      if (result && Object.keys(result).length > 0) {
        await Store.commit("setMenudataInfo", result);
      } else {
        next({ name: "Logout" });
        return;
      }
    } catch (error) {
      console.error("Failed to load menu data:", error);
      next({ name: "notfound" });
      return;
    }
  }

  // Ensure user info is loaded
  const _userInfo = Store.state.cognitoInfo;
  if (
    _userInfo &&
    (_userInfo.companyid == null ||
      _userInfo.companyid == undefined ||
      _userInfo.companyid == "")
  ) {
    try {
      const userRes = await DataLayerService.get("/user/getuserinfo");
      if (userRes) {
        if (
          userRes.companyId == "" ||
          userRes.companyId == null ||
          userRes.companyId == undefined
        ) {
          next({ name: "Logout" });
          return;
        }
        var mainres = {};
        mainres.email = _userInfo.email;
        mainres.username = _userInfo.username;
        mainres.displayname = userRes.displayName;
        mainres.companyid = userRes.companyId;
        mainres.companyname = userRes.companyName;
        mainres.companylist = userRes.companyIdList;
        mainres.role = userRes.role;
        mainres.token = Store.state.cognitoInfo.token;
        await Store.commit("setCognitoInfo", mainres);
      } else {
        next({ name: "Logout" });
        return;
      }
    } catch (error) {
      console.error("Failed to load user info:", error);
      next({ name: "Logout" });
      return;
    }
  }

  // Ensure route data is loaded
  if (
    !Store.state.routedataInfo ||
    Object.keys(Store.state.routedataInfo).length === 0
  ) {
    try {
      const result = await DataLayerService.get("/home/GetActiveRole");
      if (result && result.length > 0) {
        await Store.commit("setRoutedataInfo", result);
      } else {
        next({ name: "Logout" });
        return;
      }
    } catch (error) {
      console.error("Failed to load route data:", error);
      next({ name: "notfound" });
      return;
    }
  }
  
  // Validate the route exists in the user's allowed routes
  let checkRoute;
  if (to.name) {
    
    // Check if the route exists in the user's allowed routes
    checkRoute = Store.state.routedataInfo?.find(
      (x) => x.name.toLowerCase() === to.name.toLowerCase()
    );
    
    // If route not found, also check if it's a valid route in the router but not in allowed routes
    if (!checkRoute) {
      next({ name: "notfound" });
      return;
    }
    
  } else {
    // If no route name is found, it means the route doesn't exist in the router
    next({ name: "notfound" });
    return;
  }
  
  next();
});

export default router;